export default __webpack_public_path__ + "fontawesome-webfont.20fd1704ea223900efa9.woff2";